import { render, staticRenderFns } from "./CBC_Images.vue?vue&type=template&id=366c48ee&scoped=true"
import script from "./CBC_Images.vue?vue&type=script&lang=js"
export * from "./CBC_Images.vue?vue&type=script&lang=js"
import style0 from "./CBC_Images.vue?vue&type=style&index=0&id=366c48ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c48ee",
  null
  
)

export default component.exports